import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GolferIcon } from '../../../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as CheckCircle } from '../../../../../assets/images/common/icons/check-circle.svg'
import { ReactComponent as CancelCircle } from '../../../../../assets/images/common/icons/cancel-circle.svg'
import StockProfilePic from '../../../../../assets/images/mock/default-profile-icon.png'
import SubmitButton from '../../../../common/buttons/SubmitButton'
import classNames from 'classnames'

import styles from './SessionCard.module.scss'

const EventCard = ({ event, handleRSVP }) => {
  const { t } = useTranslation()
  const enrollment = event.students[0].enrollment
  const rsvpLocked = enrollment.removedFromWaitlist
  const waitlist = event.capacityReached && event.hasWaitlistEnabled && !rsvpLocked && ['waitlisted', 'created'].includes(enrollment.status)
  const RSVPDisabled = event.rsvpStatus !== 'open'
  const renderStatus = () => {
    switch (enrollment.status) {
      default:
      case 'confirmed':
        return <div className={styles.attending}>
          <CheckCircle className='mr-2'/> {t('dashboard.student.eventCard.attending')}
        </div>

      case 'declined':
        return <div className={styles.notAttending}>
          <CancelCircle className='mr-2'/> {t('dashboard.student.eventCard.notAttending')}
        </div>

      case 'waitlisted':
        return (
          <div className={styles.waitlisted}>
            {t('dashboard.student.eventCard.waitlistedPosition', { waitlistOrder: enrollment.waitlistOrder })}
          </div>
        )
    }
  }
  return (
    <div className={styles.sessionCard}>
      <div className={styles.header}>
        <p className={styles.title}>{`${event.seriesName} - ${event.name}`}</p>
      </div>
      <p className={styles.subtitle}>{event.format}</p>

      <div>
        <i className={`fa fa-clock-o ${styles.faIcon}`}/>
        <span className={styles.text}>
          {event.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).toLowerCase()}
        </span>
      </div>

      {
        event.location &&
        <div>
          <i className={`fa fa-map-marker ${styles.faIcon}`}/><span className={styles.text}>{event.location}</span>
        </div>
      }

      <div className={styles.enrollments}>
        <GolferIcon className={styles.icon}/>
        <span className={styles.textStudents}>{t('dashboard.student.eventCard.studentCount', { count: event.students.length })}</span>
      </div>

      <div className={styles.studentsProfiles}>
        {event.students.slice(0, 4).map((student) =>
          <div
            className={styles.profileImg}
            key={student.id}
            style={{
              backgroundImage: student.avatarUrl
                ? `url(${student.avatarUrl})`
                : `url(${StockProfilePic})`,
            }}
          />
        )}
        {event.students.length > 4 && <div className={styles.moreProfiles}>+ {event.students.length - 4} more</div>}
      </div>
      {
        enrollment.status === 'created' ?
          <SubmitButton
            onClick={(e) => { e.preventDefault(); handleRSVP(waitlist) }}
            buttonMessage={
              waitlist
                ? t('dashboard.student.eventCard.joinWaitlist')
                : event.rsvpStatus === 'open' ? t('dashboard.student.eventCard.rsvpOpen') : t('dashboard.student.eventCard.rsvpClosed')
            }
            buttonColor='orange-button'
            disabled={RSVPDisabled && !waitlist}
          />
          :
          <div
            className={classNames(enrollment.status === 'waitlisted' ? styles.waitlistedStatus : styles.rsvpStatus,
              { [styles.disabled]: RSVPDisabled && !waitlist })
            }
            onClick={() => handleRSVP(waitlist)} aria-hidden='true'
          >
            {renderStatus()}
          </div>
      }
    </div>
  )
}

EventCard.propTypes = {
  event: PropTypes.shape({
    date: PropTypes.object,
    location: PropTypes.string,
    id: PropTypes.number,
    seriesName: PropTypes.string,
    name: PropTypes.string,
    format: PropTypes.string,
    students: PropTypes.array,
    rsvpStatus: PropTypes.string,
    capacityReached: PropTypes.bool,
    hasWaitlistEnabled: PropTypes.bool,
    leadCoachPhone: PropTypes.string,
  }),
  handleRSVP: PropTypes.func.isRequired,
}

export default EventCard
